import s from "./guide.module.css";
import { fmtDate } from "@/components/sci/useSciPreview";

// AI-outlook module (wua-subject-ai-outlook/1): visible paragraph, sources and review date beneath.
export function AiOutlook({ ai }) {
  if (!ai) return null;
  return (
    <section className={s.ai} aria-labelledby="student-ai-heading" data-testid="student-ai-outlook">
      <h3 id="student-ai-heading">{ai.heading}</h3>
      <p data-testid="student-ai-paragraph">{ai.paragraph}</p>
      <p className={s.status} data-testid="student-ai-reviewed">Reviewed {fmtDate(ai.reviewed_at)}</p>
      <details data-testid="student-ai-sources">
        <summary>Sources and what they cover</summary>
        <ul>
          {ai.sources.map((src) => (
            <li key={src.url}>
              <a href={src.url} target="_blank" rel="noopener noreferrer">{src.provider}: {src.title}</a>
              {src.published_or_updated && <span className={s.status}> · {src.published_or_updated}</span>}
              <br /><span className={s.status}>{src.supports}</span>
            </li>
          ))}
        </ul>
        <p className={s.source}><strong>Evidence scope:</strong> {ai.evidence_scope}</p>
        <p className={s.source}><strong>Editorial inference:</strong> {ai.inference}</p>
      </details>
    </section>
  );
}
